<template>
    <div class="row">
        <div class="col-12">
            <h4>Company address</h4>
        </div>
        <div class="col-12">
            <form-input :placeholder="$t(shop ? 'COMPANYDATA.shopName' : 'COMMON.companyName')"
                        :elementID="shop ? 'shopName' : 'companyName'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.address.companyName"
                        v-model="address.companyName">
            </form-input>
        </div>
        
        <div class="col-9">
            <form-input :placeholder="$t('COMPANYDATA.street')"
                        :elementID="'addressStreet'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.address.street"
                        v-model="address.street">
            </form-input>
        </div>
        
        <div class="col-3">
            <form-input :placeholder="$t('COMPANYDATA.streetNumber')"
                        :elementID="'addressStreetNumber'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.address.streetNumber"
                        v-model="address.streetNumber">
            </form-input>
        </div>
        
        <div class="col-12 col-sm-6 col-md-4 col-lg-4">
            <form-input :placeholder="$t('COMPANYDATA.postCode')"
                        :elementID="'addressPostCode'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.address.postCode"
                        v-model="address.postCode">
            </form-input>
        </div>
        
        <div class="col-12 col-sm-6 col-md-4 col-lg-4">
            <form-input :placeholder="$t('COMPANYDATA.city')"
                        :elementID="'addressCity'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.address.city"
                        v-model="address.city">
            </form-input>
        </div>
        
        <div class="col-12 col-sm-6 col-md-4 col-lg-4">
            <form-input :placeholder="$t('COMPANYDATA.country')"
                        :elementID="'country'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.address.country"
                        v-model="address.country">
            </form-input>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-4">
            <form-input :placeholder="$t('COMPANYDATA.zone')"
                        :elementID="'zone'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.address.zone"
                        v-model="address.zone">
            </form-input>
        </div>
    </div>
</template>
<script>
import FormInput from '../../../../../Shared/UI/Form/FormInput.vue';
import { required, minLength } from 'vuelidate/lib/validators';

export default {
    name: 'address-data',
    components: {FormInput},
    props: {
        address: {},
        shop: {
            type: Boolean,
            default: false
        }
    },
    validations: {
        address: {
            companyName: {
                required,
                minLength: minLength(1)
            },
            street: {
                required
            },
            streetNumber: {
                required
            },
            postCode: {
                required
            },
            city: {
                required
            },
            country: {
                required
            },
            zone: {
                required
            }
        }
    }
};
</script>
